import styles from './styles.module.scss'

export default function Modal({ children, onClick, className = "" }){
  return (
    <div className={ `${styles.modal} ${className}` } onClick={onClick}>
      { children }
    </div>
  );
}